import AppRoutes from "./components/AppRoutes";

const App = () => {
    return(
        <AppRoutes/>
    );
};

export default App;